import { store } from '@atredux/store'
import { getOpenModalCalledWithMigratedTool } from '@src/redux/selectors/toolSelector'
import { switchToLastMigratedTool } from '@src/redux/slices/toolSlice'
import { switchToMigratedIFrame } from '@src/utils/ModalSwitchUtil'

export async function modalClosedListener () {
    console.log('ATBase: Received modal closed event...')
    const wasOpenModalCalledFromMigratedTool = getOpenModalCalledWithMigratedTool(store.getState())

    if (wasOpenModalCalledFromMigratedTool) {
        switchToMigratedIFrame()
    }

    return true
}
